// Generated L layer lookup table
// Contains flattened taxonomy for Looks

export const L_LAYER_LOOKUP = {
  PRF: {
    numericCode: '001',
    name: 'Modern_Performance',
  },
  'PRF.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'PRF.LEO': {
    numericCode: '002',
    name: 'Leotard',
  },
  'PRF.SEQ': {
    numericCode: '003',
    name: 'Sequined',
  },
  'PRF.LED': {
    numericCode: '004',
    name: 'LED',
  },
  'PRF.ATH': {
    numericCode: '005',
    name: 'Athletic',
  },
  'PRF.MIN': {
    numericCode: '006',
    name: 'Minimalist',
  },
  'PRF.SPK': {
    numericCode: '007',
    name: 'Sparkly_Dress',
  },
  TRD: {
    numericCode: '002',
    name: 'Traditional_Attire',
  },
  'TRD.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'TRD.KIM': {
    numericCode: '002',
    name: 'Kimono',
  },
  'TRD.SAR': {
    numericCode: '003',
    name: 'Sari',
  },
  'TRD.KLT': {
    numericCode: '004',
    name: 'Kilt',
  },
  'TRD.HAN': {
    numericCode: '005',
    name: 'Hanbok',
  },
  'TRD.CHG': {
    numericCode: '006',
    name: 'Cheongsam',
  },
  STG: {
    numericCode: '003',
    name: 'Stage_Ready',
  },
  'STG.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'STG.BRF': {
    numericCode: '002',
    name: 'Black_Ruffled',
  },
  'STG.RLE': {
    numericCode: '003',
    name: 'Red_Leather',
  },
  'STG.GCK': {
    numericCode: '004',
    name: 'Gold_Cocktail',
  },
  'STG.WBL': {
    numericCode: '005',
    name: 'White_Blouse',
  },
  'STG.CGR': {
    numericCode: '006',
    name: 'Casual_Grey',
  },
  'STG.TBZ': {
    numericCode: '007',
    name: 'Tailored_Blazer',
  },
  'STG.NEO': {
    numericCode: '008',
    name: 'Neon',
  },
  'STG.MTL': {
    numericCode: '009',
    name: 'Metallic',
  },
  CAS: {
    numericCode: '004',
    name: 'Casual',
  },
  'CAS.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'CAS.STR': {
    numericCode: '002',
    name: 'Streetwear',
  },
  'CAS.DNM': {
    numericCode: '003',
    name: 'Denim',
  },
  'CAS.ATL': {
    numericCode: '004',
    name: 'Athleisure',
  },
  'CAS.BOH': {
    numericCode: '005',
    name: 'Boho',
  },
  'CAS.MIN': {
    numericCode: '006',
    name: 'Minimal',
  },
  DSG: {
    numericCode: '005',
    name: 'Designer',
  },
  'DSG.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'DSG.COU': {
    numericCode: '002',
    name: 'Couture',
  },
  'DSG.RUN': {
    numericCode: '003',
    name: 'Runway',
  },
  'DSG.LUX': {
    numericCode: '004',
    name: 'Luxury',
  },
  'DSG.HFA': {
    numericCode: '005',
    name: 'High_Fashion',
  },
  'DSG.BSP': {
    numericCode: '006',
    name: 'Bespoke',
  },
  URB: {
    numericCode: '006',
    name: 'Urban',
  },
  'URB.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'URB.HIP': {
    numericCode: '002',
    name: 'Hip_Hop',
  },
  'URB.GRF': {
    numericCode: '003',
    name: 'Graffiti',
  },
  'URB.TEC': {
    numericCode: '004',
    name: 'Techwear',
  },
  'URB.SKT': {
    numericCode: '005',
    name: 'Skater',
  },
  'URB.PNK': {
    numericCode: '006',
    name: 'Punk',
  },
  VIN: {
    numericCode: '007',
    name: 'Vintage',
  },
  'VIN.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'VIN.SIX': {
    numericCode: '002',
    name: '60s',
  },
  'VIN.SEV': {
    numericCode: '003',
    name: '70s',
  },
  'VIN.EGT': {
    numericCode: '004',
    name: '80s',
  },
  'VIN.NIN': {
    numericCode: '005',
    name: '90s',
  },
  'VIN.RET': {
    numericCode: '006',
    name: 'Retro',
  },
  CUL: {
    numericCode: '008',
    name: 'Cultural',
  },
  'CUL.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'CUL.AFR': {
    numericCode: '002',
    name: 'African',
  },
  'CUL.IND': {
    numericCode: '003',
    name: 'Indian',
  },
  'CUL.MDE': {
    numericCode: '004',
    name: 'Middle_Eastern',
  },
  'CUL.LAT': {
    numericCode: '005',
    name: 'Latin',
  },
  'CUL.ASN': {
    numericCode: '006',
    name: 'Asian',
  },
  FUT: {
    numericCode: '009',
    name: 'Futuristic',
  },
  'FUT.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'FUT.CYB': {
    numericCode: '002',
    name: 'Cyberpunk',
  },
  'FUT.SPC': {
    numericCode: '003',
    name: 'Space',
  },
  'FUT.HOL': {
    numericCode: '004',
    name: 'Holographic',
  },
  'FUT.TEC': {
    numericCode: '005',
    name: 'Tech',
  },
  'FUT.SCI': {
    numericCode: '006',
    name: 'Sci_Fi',
  },
  FAN: {
    numericCode: '010',
    name: 'Fantasy',
  },
  'FAN.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'FAN.MED': {
    numericCode: '002',
    name: 'Medieval',
  },
  'FAN.FAI': {
    numericCode: '003',
    name: 'Fairy',
  },
  'FAN.MYT': {
    numericCode: '004',
    name: 'Mythical',
  },
  'FAN.MAG': {
    numericCode: '005',
    name: 'Magical',
  },
  'FAN.ELV': {
    numericCode: '006',
    name: 'Elven',
  },
  Y2K: {
    numericCode: '011',
    name: 'Y2K_Fashion',
  },
  'Y2K.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'Y2K.E2K': {
    numericCode: '002',
    name: 'Early_2000s',
  },
  'Y2K.L9T': {
    numericCode: '003',
    name: 'Late_90s',
  },
  'Y2K.MIL': {
    numericCode: '004',
    name: 'Millennium',
  },
  'Y2K.POP': {
    numericCode: '005',
    name: 'Pop_Princess',
  },
  'Y2K.BOY': {
    numericCode: '006',
    name: 'Boy_Band',
  },
  SUS: {
    numericCode: '012',
    name: 'Sustainable_Fashion',
  },
  'SUS.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'SUS.UPC': {
    numericCode: '002',
    name: 'Upcycled',
  },
  'SUS.ECO': {
    numericCode: '003',
    name: 'Eco_Friendly',
  },
  'SUS.MIN': {
    numericCode: '004',
    name: 'Minimalist',
  },
  'SUS.NAT': {
    numericCode: '005',
    name: 'Natural_Materials',
  },
  'SUS.VRE': {
    numericCode: '006',
    name: 'Vintage_Reuse',
  },
  DIG: {
    numericCode: '013',
    name: 'Digital_Fashion',
  },
  'DIG.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'DIG.NFT': {
    numericCode: '002',
    name: 'NFT_Wearables',
  },
  'DIG.DON': {
    numericCode: '003',
    name: 'Digital_Only',
  },
  'DIG.ARF': {
    numericCode: '004',
    name: 'AR_Fashion',
  },
  'DIG.VCO': {
    numericCode: '005',
    name: 'Virtual_Couture',
  },
  'DIG.W3S': {
    numericCode: '006',
    name: 'Web3_Style',
  },
  SPO: {
    numericCode: '014',
    name: 'Sportswear',
  },
  'SPO.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'SPO.TRK': {
    numericCode: '002',
    name: 'Tracksuit',
  },
  'SPO.ATH': {
    numericCode: '003',
    name: 'Athletic_Wear',
  },
  'SPO.GYM': {
    numericCode: '004',
    name: 'Gymwear',
  },
};

export const L_SUBCATEGORIES = {
  PRF: [
    'PRF.BAS',
    'PRF.LEO',
    'PRF.SEQ',
    'PRF.LED',
    'PRF.ATH',
    'PRF.MIN',
    'PRF.SPK',
  ],
  TRD: ['TRD.BAS', 'TRD.KIM', 'TRD.SAR', 'TRD.KLT', 'TRD.HAN', 'TRD.CHG'],
  STG: [
    'STG.BAS',
    'STG.BRF',
    'STG.RLE',
    'STG.GCK',
    'STG.WBL',
    'STG.CGR',
    'STG.TBZ',
    'STG.NEO',
    'STG.MTL',
  ],
  CAS: ['CAS.BAS', 'CAS.STR', 'CAS.DNM', 'CAS.ATL', 'CAS.BOH', 'CAS.MIN'],
  DSG: ['DSG.BAS', 'DSG.COU', 'DSG.RUN', 'DSG.LUX', 'DSG.HFA', 'DSG.BSP'],
  URB: ['URB.BAS', 'URB.HIP', 'URB.GRF', 'URB.TEC', 'URB.SKT', 'URB.PNK'],
  VIN: ['VIN.BAS', 'VIN.SIX', 'VIN.SEV', 'VIN.EGT', 'VIN.NIN', 'VIN.RET'],
  CUL: ['CUL.BAS', 'CUL.AFR', 'CUL.IND', 'CUL.MDE', 'CUL.LAT', 'CUL.ASN'],
  FUT: ['FUT.BAS', 'FUT.CYB', 'FUT.SPC', 'FUT.HOL', 'FUT.TEC', 'FUT.SCI'],
  FAN: ['FAN.BAS', 'FAN.MED', 'FAN.FAI', 'FAN.MYT', 'FAN.MAG', 'FAN.ELV'],
  Y2K: ['Y2K.BAS', 'Y2K.E2K', 'Y2K.L9T', 'Y2K.MIL', 'Y2K.POP', 'Y2K.BOY'],
  SUS: ['SUS.BAS', 'SUS.UPC', 'SUS.ECO', 'SUS.MIN', 'SUS.NAT', 'SUS.VRE'],
  DIG: ['DIG.BAS', 'DIG.NFT', 'DIG.DON', 'DIG.ARF', 'DIG.VCO', 'DIG.W3S'],
  SPO: ['SPO.BAS', 'SPO.TRK', 'SPO.ATH', 'SPO.GYM'],
};
